const skillsData = [
    {
      category: "Programming Languages",
      skills: [
        "JavaScript",
        "Typescript",
        "C#",
        "C",
        "C++",
        "Python",
        "Java",
        "MATLAB"
      ]
    },
    {
      category: "Web Development",
      skills: [
        "VueJS",
        "React",
        "HTML5",
        "CSS3",
        "Tailwind CSS",
        "SEO Optimization"
      ]
    },
    {
      category: "Tools & Frameworks",
      skills: [
        "NodeJS",
        "MongoDB",
        "Git",
        "Cloudflare",
        "Microsoft Suite",
        "Power Automate",
        "JMP",
        "AutoCAD",
        "Fusion360",
        "LTSpice",
      ]
    },
    {
      category: "Soft Skills",
      skills: [
        "Teamwork",
        "Leadership",
        "Problem-solving",
        "Communication",
        "Adaptability",
        "Prompt Engineering",
        "UX/UI Design",
        "Marketing"
      ]
    }
  ];
  
  export default skillsData;
  